import React from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    DateField,
    NumberField
} from 'react-admin';
import { Chip } from '@material-ui/core';
import {useTranslation} from 'react-i18next';

const StatusField = ({ record, source }) => {
    const {t} = useTranslation();
    
    if (!record || !record[source]) {
        return null;
    }
    
    const getChipColor = (status) => {
        switch (status) {
            case 'queued':
                return 'primary';
            case 'sent':
                return 'default';
            case 'failed':
                return 'secondary';
            case 'cancelled':
                return 'default';
            case 'skipped':
                return 'default';
            default:
                return 'default';
        }
    };

    const getStatusLabel = (status) => {
        switch (status) {
            case 'queued':
                return t('drip.enrollment.status.queued');
            case 'sent':
                return t('drip.enrollment.status.sent');
            case 'failed':
                return t('drip.enrollment.status.failed');
            case 'cancelled':
                return t('drip.enrollment.status.cancelled');
            case 'skipped':
                return t('drip.enrollment.status.skipped');
            default:
                return status;
        }
    };

    const status = record[source];
    return (
        <Chip 
            label={getStatusLabel(status)}
            color={getChipColor(status)}
        />
    );
};

const DripEnrollmentShow = (props) => {
    const {t} = useTranslation();

    return (
        <Show {...props} title={t('drip.enrollment.show_title')}>
            <SimpleShowLayout>
                <TextField 
                    source="dripCampaignName" 
                    label={t('drip.enrollment.campaign')} 
                />
                <TextField 
                    source="contactEmail" 
                    label={t('drip.enrollment.contact_email')} 
                />
                <StatusField 
                    source="status" 
                    label={t('drip.enrollment.status.label')} 
                />
                <DateField 
                    source="scheduledSendAt" 
                    label={t('drip.enrollment.scheduled_send')}
                    showTime
                />
                <DateField 
                    source="enrolledAt" 
                    label={t('drip.enrollment.enrolled_at')}
                    showTime
                />
                <DateField 
                    source="createdAt" 
                    label={t('drip.enrollment.created_at')}
                    showTime
                />
                <NumberField 
                    source="attempts" 
                    label={t('drip.enrollment.attempts')}
                />
            </SimpleShowLayout>
        </Show>
    );
};

export default DripEnrollmentShow;